import Script from 'next/script';

type PlausibleProps = {
  variant?: string;
};

const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN;

export default function Plausible({ variant }: PlausibleProps) {
  if (!DOMAIN) return null;

  return (
    <Script
      defer
      data-domain={DOMAIN}
      event-abTestVariant={variant || undefined}
      src="https://plausible.rockalingua.com/js/script.local.pageview-props.tagged-events.js"
      strategy="afterInteractive"
    />
  );
}
